module.exports = "/images/Icon industry-ThemePark.svg?a258cac4efa58bf6045639305194a9da";